import * as userActionTypes from 'ActionTypes/userActionTypes'
import Auth from 'Services/http/auth'
import RenewToken from 'Services/http/renewToken'
import Customer from 'Services/http/customer'
//import appActions from "Actions/appActions";
import productActions from 'Actions/productActions'
import userInitialState from 'InitialStates/userInitialState'

const userActions = (function () {
    let attempts = 5
    const actions = {
        getAuthToken: (userData = {}) => {
            return (dispatch, getState) => {
                if (!userData['username'] || !userData.password) {
                    let { id } = getState().user.data
                    let { password } = getState().form.account.values
                    userData.username = id.unicity
                    userData.password = password
                }

                Auth.getToken(userData)
                    .then((res) => {
                        dispatch(actions.setToken(res.data.token))
                        let authStatus = true
                        dispatch(actions.setAuthStatus(authStatus))
                    })
                    .catch((err) => {
                        var timer = setTimeout(() => {
                            attempts -= 1
                            timer = setTimeout(dispatch(actions.getAuthToken(userData)), 500)
                        }, 500)

                        if (!attempts) {
                            clearTimeout(timer)
                            dispatch(actions.setToken(''))
                            let authStatus = false
                            dispatch(actions.setAuthStatus(authStatus))
                        }
                    })
            }
        },
        renewAuthToken: (token) => {
            return (dispatch, getState) => {
                RenewToken.get(token)
                    .then((res) => {
                        dispatch(actions.setToken(res.data.token))
                        let authStatus = true
                        dispatch(actions.setAuthStatus(authStatus))
                    })
                    .catch((err) => {
                        dispatch(actions.setToken(''))
                        let authStatus = false
                        dispatch(actions.setAuthStatus(authStatus))
                    })
            }
        },
        getUserData: () => {
            return (dispatch, getState) => {
                let { token } = getState().user
                Customer.getMe(token).done((userData) => {
                    dispatch(actions.setUserData(userData.data))
                    let authStatus = true
                    //set loginStatus
                    dispatch(actions.setAuthStatus(authStatus))
                    //get Products
                    dispatch(productActions.getProductData())
                })
            }
        },
        updateLogout: () => {
            return (dispatch) => {
                const userData = userInitialState.data,
                    token = userInitialState.token,
                    authStatus = userInitialState.loggedIn
                //remove login token
                dispatch(actions.setToken(token))
                //clear loginStatus
                dispatch(actions.setAuthStatus(authStatus))
                //clear user data
                dispatch(actions.setUserData(userData))
                //get Products
                dispatch(productActions.getProductData())
            }
        },
        setUserData: (userData) => {
            return {
                type: userActionTypes.SET_USER_DATA,
                userData,
            }
        },
        setToken: (token) => {
            return {
                type: userActionTypes.SET_TOKEN,
                token,
            }
        },
        setAuthStatus: (authStatus) => {
            return {
                type: userActionTypes.SET_AUTH_STATUS,
                authStatus,
            }
        },
    }
    return actions
})()

export default userActions



// WEBPACK FOOTER //
// ./src/store/actions/userActions.js